import { AxiosError } from 'axios'
import { ENDPOINTS } from 'constants/endpoints'
import apiInstance from 'services/api/instance'

import { handleErrorMessage } from '../errors'

export const createWebhookPix = async (
  data: InterReservationWebhookPixApiRequest,
): Promise<void> => {
  try {
    await apiInstance.post(ENDPOINTS.INTER_RESERVATION.CREATE_WEBHOOK_PIX, data)
  } catch (creationError) {
    const axiosError = creationError as AxiosError
    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}

export const listWebhookPix = async (
  data: InterReservationListWebhookPixApiRequest,
) => {
  try {
    const response = await apiInstance.post(
      ENDPOINTS.INTER_RESERVATION.LIST_WEBHOOK_PIX,
      data,
    )
    return response.data
  } catch (listError) {
    const axiosError = listError as AxiosError
    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}
